import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { DfEventService } from '@df/core/service/df-event';
import { UiComponent } from '@df/ui/ui.component';
import { DIALOG_EVENT, DialogEvent, DialogEventType } from '../../../../common/dialog/dialog.interface';
import { StoreFinderComponent } from '../../../store/store-finder.component';
import { Product } from '../../product.decorator';

export const SEE_IN_STORE_MODAL_ID = 'seeInStoreModal';

@Component({
    selector: 'product-view-see-in-store-modal',
    templateUrl: './product-view-see-in-store-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [StoreFinderComponent]
})
export class ProductViewSeeInStoreModalComponent extends UiComponent {
    readonly product = input.required<Product<IProductDataV3>>();

    private dfEventService = inject(DfEventService);

    close() {
        this.dfEventService.dispatch({
            id: DIALOG_EVENT,
            data: new DialogEvent(DialogEventType.Close, SEE_IN_STORE_MODAL_ID)
        });
    }
}
